import ApiMServer from 'services/ApiMServer';
import { getAssistenciaById, getAssistencias } from '../Assistencias/assistenciasApi';
import { getLoggedAssistenciaId } from './assistenciasComprarSenhasUtils';

export const loadAssistenciaForLoggedUser = async (user, jwtPayload) => {
  const assistenciaId = getLoggedAssistenciaId(user, jwtPayload);

  if (assistenciaId) {
    const assistencia = await getAssistenciaById(assistenciaId);
    if (assistencia) return assistencia;
  }

  const email = (user?.email || '').trim().toLowerCase();
  if (!email) return null;

  const list = await getAssistencias();
  const byExactEmail = list.find((item) => (item.email || '').toLowerCase() === email);
  if (byExactEmail) return byExactEmail;

  const domain = email.includes('@') ? email.substring(email.indexOf('@')) : '';
  if (!domain) return null;

  return list.find((item) => {
    const itemEmail = (item.email || '').toLowerCase();
    return itemEmail.endsWith(domain) || domain.endsWith(itemEmail.substring(itemEmail.indexOf('@')));
  }) || null;
};

/**
 * Registra compra antecipada de chaves para a assistência logada.
 * Ajuste o endpoint quando o backend estiver disponível.
 */
export const comprarSenhasAssistencia = async (payload) => {
  const { data } = await ApiMServer.post('/api/v1/assistencias/comprar-senhas', payload);
  return data;
};
